const getCurrentLocale = () => document.documentElement.lang;

export default getCurrentLocale;
